function init_portal_popup() {
    $('.js-portal-popup').on('click', function() {
        console.log('clicked');
      $('body').toggleClass('portal-popup-open')
    }); 
    
    $('.portal-popup__backdrop, .portal-popup__close').on('click', function() {
      $('body').removeClass('portal-popup-open')
    });
}

$(document).ready(function() {
    init_portal_popup(); 
});
   